import React, { useEffect } from 'react';
import { SocialNudgeProps } from './types';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import {
  getSocialProofData,
  socialProofTrackingData,
} from 'helpers/socialProof';
import { TextNudgeWrapper } from './Styled/Card';
import TextNudge from '@nykaa/ui-kit/component/TextNudge';
import { pushData } from '@nykaa/data-layer';
import { useGetNudgesState } from 'hooks/priceFluctuation';
import { useIsOfferExperimentEnabled } from 'hooks/coupons';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { PRIVE_CTA_DISABLE } from 'constants/experiments';

const SocialNudge = ({
  product,
  areCornersRounded,
  addMarginBottom,
  earlyAccessData,
}: SocialNudgeProps) => {
  const { social_proof_nudges } = product;
  const { priveText } = earlyAccessData || {};

  const socialProofExperimentSuccess = useSelector(
    (state: State) => state.remoteConfig.switches.socialProofExperimentSuccess
  );
  const isCtaDisableExp = useSelector((state: State) =>
    getEligibleForVariant(state, PRIVE_CTA_DISABLE, 'A')
  );

  const {
    priceFluctuationVisible,
    differentitalPricingVisible,
    differentialSaleTimer,
  } = useGetNudgesState();

  let socialProofData = getSocialProofData(
    social_proof_nudges,
    socialProofExperimentSuccess
  );
  const offerExpState = useIsOfferExperimentEnabled();

  let showNudge =
    socialProofExperimentSuccess &&
    socialProofData &&
    product?.inStock &&
    !priceFluctuationVisible &&
    !differentitalPricingVisible &&
    (!isCtaDisableExp || !priveText);

  useEffect(() => {
    const trackingData = socialProofTrackingData(
      showNudge,
      social_proof_nudges?.eligible_nudge_ids,
      socialProofData
    );
    pushData(trackingData);
  }, [showNudge, social_proof_nudges, socialProofData]);

  useEffect(() => {
    pushData({ differentialSaleTimer: differentialSaleTimer });
    return function () {
      pushData({ differentialSaleTimer: false });
    };
  }, [differentialSaleTimer]);

  if (!product) {
    return null;
  }

  return (
    <>
      {showNudge && (
        <TextNudgeWrapper
          addMarginBottom={addMarginBottom}
          offerExpState={offerExpState}
        >
          <TextNudge
            primaryText={`${
              socialProofData &&
              socialProofData.primary_text &&
              `${socialProofData.primary_text} `
            } `}
            secondaryText={socialProofData && socialProofData.secondary_text}
            gradientColor1={socialProofData?.gradient_color[0]?.bg_color}
            gradientColor2={socialProofData?.gradient_color[1].bg_color}
            areCornersRounded={areCornersRounded}
          ></TextNudge>
        </TextNudgeWrapper>
      )}
    </>
  );
};

export default SocialNudge;
